import { useDispatch } from "react-redux"
import { setCart } from "../../Redux/Slices/cartSlice"

export default function Product({data}){
    const dispatch = useDispatch()

    const addToCart = (e) => {
        e.preventDefault()
        dispatch(setCart(data))
    }

    return(
        <section className="py-5">
            <div className="container px-4 px-lg-5 my-5">
                <div className="row gx-4 gx-lg-5 align-items-center">
                    <div className="col-md-6"><img className="card-img-top mb-5 mb-md-0" src={data.images} alt="..." /></div>
                    <div className="col-md-6">
                        <div className="small mb-1">{data.sku}</div>
                        <h1 className="display-5 fw-bolder">{data.name}</h1>
                        <div className="fs-5 mb-5">
                            <span className="text-decoration-line-through">{data.sale}</span>
                            <span>{data.price}</span>
                        </div>
                        <p className="lead">{data.description}</p>
                        <div className="d-flex">
                            <input className="form-control text-center me-3" id="inputQuantity" type="num" defaultValue="1" style={{maxWidth: "3rem"}} />
                            <button className="btn btn-outline-dark flex-shrink-0" type="button" onClick={addToCart}>
                                <i className="bi-cart-fill me-1"></i>
                                اضافه به سبد
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}